import * as React   from 'react'
import ReactDOM     from 'react-dom/client'
import HeartRateApp from './components/HeartRateApp'
import HowUse       from '../../shared/how_use/HowUse'
import GoogleAd     from '../../components/google/GoogleAd'


class OnLoad {
  run() {
    this.initWindowApp()
    this.initReactAssets()
    this.runOnDOM()
    this.runOnLoad()
  }

  runOnDOM() {
    // just DOM loaded (not all resources)
    document.addEventListener('DOMContentLoaded', () => {
      this.initMenuToggle()
    })
  }

  runOnLoad() {
    // all resources have loaded
    window.addEventListener('load', () => {
    })
  }

  initWindowApp() {
    if(!window.app) window.app = {
      components: {}
    }
  }

  initReactAssets() {
    window.app.React                   = React
    window.app.ReactDOM                = ReactDOM
    window.app.components.HeartRateApp = HeartRateApp
    window.app.components.HowUse       = HowUse
    window.app.components.GoogleAd     = GoogleAd
  }

  // gives menu toggle elements toggle behavior
  initMenuToggle() {
     document.querySelectorAll('.menu-toggle').forEach(
       node => {
         node.addEventListener(
           'click',
           (ev) => {
             ev.preventDefault()
             const menu = document.querySelector('#menu')
             menu.classList.toggle('mobile-on');
           }
         )
       }
     )
  }
}

export default new OnLoad
